module.exports = "<div class='addCampaignModal hid'>\n    <div class='addCampaign'>\n        <h6>Campaign</h6>\n        <div class='addRow'>\n            <div class='column'>\n                <div class='inputGroup'>\n                    <input (input)='changeInput($event)' [value]='title' placeholder='Campaign' class='formControl' />\n                </div>\n            </div>\n        </div>\n        <button (click)=\"submit()\" class='save'>Save</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/budget/add/add.component.html
// module id = ./src/app/components/budget/add/add.component.html
// module chunks = main